export default "__VITE_ASSET__BVXgakKe__"